import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { Lock, ShieldCheck, KeyRound, Globe2, FileCheck, Server } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MarketingLayout, SectionHeader, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/security")({
 head: () => buildSeo({
 path: "/security",
 title: "Security at Reality Twin — How we protect your data",
 description: "How Reality Twin protects data: encryption, per-workspace isolation, Swiss/EU hosting, GDPR/FADP-aligned practices.",
 }),
 component: SecurityPage,
});

const ICONS = [Lock, KeyRound, ShieldCheck, Globe2, Server, FileCheck];

function SecurityPage() {
 const { t } = useTranslation();
 const pillars = t("routes.security.pillars", { returnObjects: true }) as { title: string; desc: string }[];
 const sections = t("routes.security.sections", { returnObjects: true }) as { h2: string; body: string }[];
 return (
 <MarketingLayout>
 <I18nPageHero tKey="pages.security" />

 <section className="py-20">
 <div className="mx-auto max-w-6xl px-6">
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border hairline rounded-xl overflow-hidden">
 {pillars.map((p, i) => {
 const Icon = ICONS[i]?? Lock;
 return (
 <div key={p.title} className="bg-card p-7">
 <Icon className="h-5 w-5" strokeWidth={1.5} />
 <h3 className="mt-6 font-serif text-[22px] leading-tight">{p.title}</h3>
 <p className="mt-2 text-[13.5px] leading-relaxed text-muted-foreground">{p.desc}</p>
 </div>
 );
 })}
 </div>
 </div>
 </section>

 <section className="bg-cream border-y border-border py-24">
 <div className="mx-auto max-w-6xl px-6">
 <SectionHeader eyebrow={t("routes.security.progEyebrow")} title={<>{t("routes.security.progTitleA")}<em className="italic text-muted-foreground">{t("routes.security.progTitleEm")}</em></>} />
 </div>
 <div className="mx-auto max-w-3xl px-6 py-12 text-[15.5px] leading-[1.7] text-muted-foreground">
 {sections.map((s) => (
 <div key={s.h2} className="mb-8">
 <h2 className="font-serif text-[28px] text-foreground mb-3 tracking-[-0.025em]">{s.h2}</h2>
 <p className="[&_a]:underline [&_a]:text-foreground" dangerouslySetInnerHTML={{ __html: s.body }} />
 </div>
 ))}
 </div>
 </section>
 </MarketingLayout>
 );
}
